import React from 'react'
import { Grid, makeStyles } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '99%',
    borderRadius: 24,
    background: '#FFFFFF',
    paddingBottom: 0,
    marginLeft: 5,
    marginTop: 3
  }
}))

const PatientsScanningScheduleHeaderSkeleton = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Grid container className={classes.header} spacing={2} alignItems="center">
        <Grid item>
          <Skeleton variant="text" width={280} height={50} />
        </Grid>
      </Grid>
      <Grid container className={classes.header} spacing={2} alignItems="center">
        <Grid item>
          <Skeleton variant="text" width={150} height={50} />
        </Grid>
        <Grid item>
          <Skeleton variant="text" width={120} height={50} />
        </Grid>
        <Grid item>
          <Skeleton variant="text" width={120} height={50} />
        </Grid>
      </Grid>
    </div>
  )
}

export default PatientsScanningScheduleHeaderSkeleton
